import React, {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import {
  Button,
  Card,
  Checkbox,
  Col,
  Input,
  Modal,
  Row,
  // Table,
  // Tooltip,
  Typography,
} from "antd";
import {
  CustomerOrderInfo,
  NotificationInfo,
  SubscriptionInfo,
  UserInfo,
} from "../../../context";
import { PrinterOutlined } from "@ant-design/icons";
import moment from "moment";
import MerchantEmployeeLayout from "../../layout/MerchantEmployeeLayout";
import axios from "axios";
import { useReactToPrint } from "react-to-print";
// import MerchantOrdersDetails from "./MerchantOrdersDetails";

const MerchantEmployeeProduction = () => {
  const [search, setSearch] = useState("");
  // const tableLayout = "";
  // const scroll = {};
  const { handleLogoutTkn, userData } = useContext(UserInfo);
  // const [openDrawer, setOpenDrawer] = useState(false);
  // const [selectedData, setSelectedData] = useState(null);
  // const [loading, setLoading] = useState(false);
  const { subscriptionDetails } = useContext(SubscriptionInfo);
  const dateNow = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
  const { toProductionList, rerunToProduction } = useContext(CustomerOrderInfo);
  // const selectedOptions = [];
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const { rerunNotif } = useContext(NotificationInfo);
  const [displayDetailsPrint, setDisplayDetailsPrint] = useState(false);

  // const componentRef = useRef();
  const [selectedCard, setSelectedCard] = useState(null);
  const refsArray = useRef([]);

  // console.log("refsArray: ", refsArray);

  // console.log("userData: ", userData.data.usersmerchantemployee.station_id);

  // console.log("toProductionList", toProductionList);
  // console.log("selectedOptions", selectedOptions);
  // console.log("selectedOptions length", selectedOptions.length);

  // const tableProps = {
  //   bordered: false,
  //   loading,
  //   size: "medium",
  //   // expandable,
  //   showHeader: true,
  //   scroll,
  //   tableLayout,
  // };

  // const columns = [
  //   {
  //     title: "Transaction Number",
  //     dataIndex: "transaction_id",
  //     render: (text, record) => (
  //       <p
  //         style={{
  //           textTransform: "uppercase",
  //           fontWeight: "bold",
  //         }}
  //       >
  //         {text}
  //       </p>
  //     ),
  //   },
  //   {
  //     title: "Customer Name",
  //     dataIndex: "customer_name",
  //     render: (text, record) => <p>{text}</p>,
  //   },
  //   {
  //     // title: "Table Number",
  //     title: "Location",
  //     dataIndex: "table_no",
  //     render: (text, record) => <p>{text !== "Table #" ? text : ""}</p>,
  //   },
  //   {
  //     title: "Status",
  //     dataIndex: "service_category",
  //     align: "center",
  //     render: (text, record) => (
  //       <p
  //         style={{
  //           textTransform: "uppercase",
  //           color:
  //             text === "dine"
  //               ? "green"
  //               : text === "pickup"
  //               ? "#aeaeae"
  //               : text === "delivery"
  //               ? "#b804c2"
  //               : "blue",
  //           fontWeight: "bold",
  //         }}
  //       >
  //         {text === "dine"
  //           ? "DINE"
  //           : text === "pickup"
  //           ? "PICK UP"
  //           : text === "delivery"
  //           ? "DELIVERY"
  //           : "TAKE OUT"}
  //       </p>
  //     ),
  //   },
  //   {
  //     title: "",
  //     dataIndex: "",
  //     align: "center",
  //     width: 40,
  //     render: (text) => (
  //       <p>
  //         <Tooltip title="Order Details">
  //           <Button
  //             type="dashed"
  //             shape="circle"
  //             onClick={() => {
  //               setSelectedData(text);
  //               setOpenDrawer(true);
  //             }}
  //             icon={<AuditOutlined />}
  //             style={{ marginRight: 10 }}
  //           />
  //         </Tooltip>
  //       </p>
  //     ),
  //   },
  // ];

  // const tableColumns = columns.map((item) => ({
  //   ...item,
  //   ellipsis: false,
  // }));

  const searchable = toProductionList.data.filter((data) => {
    return (
      data.customer_name.toLowerCase().indexOf(search.toLowerCase()) >= 0 ||
      data.transaction_id.toLowerCase().indexOf(search.toLowerCase()) >= 0
    );
  });

  const handleCheckboxChange = (id) => {
    const updatedOptions = selectedOptions.includes(id)
      ? selectedOptions.filter((selectedOption) => selectedOption !== id)
      : [...selectedOptions, id];
    setSelectedOptions(updatedOptions);
  };

  const handleConfirmOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setConfirmDialog(false);
      setConfirmLoading(false);
      handleCheckedProductAsNowServing();
    }, 2000);
  };

  const handleCheckedProductAsNowServing = () => {
    const formdata = new FormData();
    formdata.append(
      "user_id",
      userData.data.usersmerchantemployee.merchant_user_id
    );
    formdata.append(
      "merchant_uid",
      userData.data.usersmerchantemployee.merchant_uid
    );
    formdata.append("employee_user_uid", userData.data.id);
    // formdata.append(
    //   "transaction_id",
    //   selectedData !== null ? selectedData.transaction_id : ""
    // );
    formdata.append("product_count", selectedOptions.length);

    for (let i = 0; i < selectedOptions.length; i++) {
      formdata.append("product_ids[]", selectedOptions[i]);
    }

    setLoadings(true);
    axios
      .post("user/merchant/new/confirm-as-now-serving", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif(
            "success",
            "Confirm product(s) as now serving successfully."
          );
          setTimeout(() => {
            setSelectedOptions([]);
            close();
            setLoadings(false);
            // setLoading(false);
            rerunToProduction();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
        console.log("ERROR: ", error);
      });
  };

  const handlePrint = useReactToPrint({
    content: () => {
      const content = selectedCard;
      return content;
    },
    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        // setPaddingPrint(10);
        // setDisplayDetailsPrint(true);
        resolve();
      });
    },
    onAfterPrint: () => {
      // setPaddingPrint(0);
      setDisplayDetailsPrint(false);
      setSelectedCard(null);
    },
  });

  useEffect(() => {
    if (selectedCard !== null) {
      setTimeout(() => {
        handlePrint();
      }, 1000);
    }
  }, [selectedCard]);

  return (
    <MerchantEmployeeLayout>
      <div style={{ overflowX: "auto" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 10,
          }}
        >
          <div style={{ flexGrow: 1 }}>
            <Input
              id="search"
              placeholder="Search transaction # or name"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{
                border: "2px solid #e5e5e5",
                width: window.innerWidth < 576 ? "100%" : 300,
              }}
              size="large"
            />
          </div>

          {searchable.length > 0 && (
            <div>
              <Button
                type="primary"
                loading={loadings}
                style={{ width: "100%", borderRadius: "20px" }}
                onClick={() => {
                  setConfirmDialog(true);
                }}
                disabled={!selectedOptions.length > 0}
              >
                Complete
              </Button>
            </div>
          )}
        </div>

        <Row>
          {searchable.length > 0 &&
            searchable.map((data, index) => (
              <Col xs={24} sm={24} md={8} lg={6} key={index}>
                <Card
                  title={
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        marginTop: "10px",
                        marginBottom: "10px",
                      }}
                    >
                      <Typography>
                        Transaction #:{" "}
                        <span style={{ fontWeight: "bold" }}>
                          {data.transaction_id}
                        </span>
                      </Typography>
                      <Typography>
                        Customer:{" "}
                        <span style={{ fontWeight: "bold" }}>
                          {data.customer_name}
                        </span>
                      </Typography>
                      <Typography>
                        Location:{" "}
                        <span style={{ fontWeight: "bold" }}>
                          {data.table_no}
                        </span>
                      </Typography>
                    </div>
                  }
                  style={{
                    margin: 2,
                    border: !displayDetailsPrint ? "2px solid red" : "none",
                  }}
                  ref={(el) => (refsArray.current[index] = el)}
                >
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    {data.groupbytransactionbreakdown.length > 0 &&
                      data.groupbytransactionbreakdown.map((data2, index2) => (
                        <Fragment key={index2}>
                          <div className="hidewhenprint">
                            <Checkbox
                              id={`checkbox-${index}`}
                              onChange={() => handleCheckboxChange(data2.id)}
                              checked={selectedOptions.includes(data2.id)}
                              style={{
                                fontSize: 16,
                                borderBottom: "1px solid #e5e5e5",
                                marginTop: 5,
                                marginBottom: 5,
                              }}
                            >
                              {parseInt(data2.is_per_piece) === 1 ? (
                                <>
                                  {data2.product}{" "}
                                  <span style={{ fontWeight: "bold" }}>
                                    {" x"}
                                    {data2.quantity}
                                  </span>
                                </>
                              ) : (
                                <>
                                  {data2.product}{" "}
                                  <span style={{ fontWeight: "bold" }}>
                                    {" - "}
                                    {data2.quantity}gram(s)
                                  </span>
                                </>
                              )}
                            </Checkbox>
                          </div>

                          <Typography className="showwhenprint">
                            {parseInt(data2.is_per_piece) === 1 ? (
                              <>
                                {data2.product}{" "}
                                <span style={{ fontWeight: "bold" }}>
                                  {" x"}
                                  {data2.quantity}
                                </span>
                              </>
                            ) : (
                              <>
                                {data2.product}{" "}
                                <span style={{ fontWeight: "bold" }}>
                                  {" - "}
                                  {data2.quantity}gram(s)
                                </span>
                              </>
                            )}
                          </Typography>
                        </Fragment>
                      ))}

                    {!displayDetailsPrint && (
                      <div style={{ display: "flex", marginTop: 10 }}>
                        <div style={{ flexGrow: 1 }} />
                        <div>
                          <Button
                            size="small"
                            type="primary"
                            onClick={() => {
                              setSelectedCard(refsArray.current[index]);
                              setDisplayDetailsPrint(true);
                            }}
                            icon={<PrinterOutlined />}
                          >
                            Print
                          </Button>
                        </div>
                      </div>
                    )}
                  </div>
                </Card>
              </Col>
            ))}
          {/* {console.log("displayDetailsPrint: ", displayDetailsPrint)} */}
        </Row>

        {/* <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={searchable.length > 0 ? searchable : []}
          scroll={scroll}
          rowKey={(record) => record.transaction_id}
        /> */}
      </div>

      {/* {openDrawer && (
        <MerchantOrdersDetails
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          setLoading={setLoading}
          getMerchantOrderSaveList={() => rerunToProduction()}
          selectedData={selectedData}
        />
      )} */}

      <Modal
        title="Subscription has ended."
        centered
        open={dateNow > subscriptionDetails.data.plan_expiry}
        footer={null}
        width={350}
        closable={false}
      >
        <div style={{ display: "flex" }}>
          <div style={{ flexGrow: 1 }} />
          <Button type="primary" onClick={() => handleLogoutTkn()}>
            Logout
          </Button>
        </div>
      </Modal>

      <Modal
        title="Are you sure to save all this checked products as now serving?"
        open={confirmDialog}
        onOk={handleConfirmOk}
        confirmLoading={confirmLoading}
        onCancel={() => setConfirmDialog(false)}
        centered
      />
    </MerchantEmployeeLayout>
  );
};

export default MerchantEmployeeProduction;
